/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_TotalInputs */

const en_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const de_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

const es_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const fr_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const nl_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal`)
};

const it_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale`)
};

const pt_br2_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const pl_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suma`)
};

const hu_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összesen`)
};

const ro_admin_external_booking_edit_order_summary_total = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_TotalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_total = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_TotalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_TotalInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_total(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_total(inputs)
	return ro_admin_external_booking_edit_order_summary_total(inputs)
});
export { admin_external_booking_edit_order_summary_total as "admin.external_booking_edit.order_summary.total" }